import React from 'react';
import Header from './Header.jsx'
// import '../styles/ProjectList.css';
import '../styles/About.css';
import ecoShoolImg from '../img/eco-school.jpg';
import healthyImg from '../img/healthy-cafe.jpg';
import kompolaImg from '../img/Kompola.jpg';
import myFoxImg from '../img/myfox.jpg';
import shpulkaImg from '../img/shpulka.png';
import doitImg from '../img/doit.png';

const About = ({ user, onLogout, setUser }) => {
  return (

    <div className="about-page">

<Header user = {user} setUser = {setUser} />
      <div className="content">
        <h1>Про платформу SocialLeanHub</h1>
        <div className="about-content">
          <section className="intro">
            <p>
              Платформа SocialLeanHub для молодих соціальних підприємців створена для того, щоб допомогти
              школярам реалізувати свої ідеї. Це ваш старт у світі соціального підприємництва!
            
            </p>
            <p>
            Наш робот-козак допоможе тобі втілити твою ідею в логічну бізнес-модель за допомогою інструменту Lean Canvas.
            </p>

            <p>
            Lean Canvas допомагає підприємцю структурувати ідею, виявити прогалини та переконатися, що модель є життєздатною. Це потужний стартовий інструмент для перетворення ідеї в реальність!
            </p>
          </section>

          <section className="examples">
            <h2>Приклади успішних проектів</h2>
            <div className="example">
              <h3>Еко-школа</h3>
              <p>
                Учні організували збір вторинної сировини (паперу, пластику)
                у своїй школі, а зібрані кошти спрямували на озеленення
                пришкільної території.
              </p>
              <img src= {ecoShoolImg} alt="Еко-школа" />
            </div>
            <div className="example">
              <h3>Кафе здорового харчування</h3>
              <p>
                Створено кафе, яке пропонує корисні перекуси, виготовлені з
                місцевих продуктів. Кошти від продажу направляються на
                підтримку благодійних ініціатив.
              </p>
              <img src={healthyImg} alt="Кафе здорового харчування" />
            </div>
            <div className="example">
              <h3>Компола (Київ)</h3>
              <p>
              2017 року 12-річні Микита Шульга та Софія-Христина Борисюк запропонували екологічну ініціативу з виготовлення компосту в школах. 
              Наступного року до ініціативи, що вже мала підтримку МОН, долучилося більше 200 шкіл. Названо її так шляхом поєднання слів «компост» і «школа». На новаторів звернули увагу донори, зокрема, «Дунайська стратегія» та ChildFund Deutschland e.V. Тепер номінанти міжнародних премій думають, як робити обкладинки з йогуртового паковання. 
              Подекуди вже відбувається комерційне використання компосту..
              </p>
              <img src= {kompolaImg} alt="Компола" />
            </div>
            <div className="example">
              <h3>Май Fox</h3>
              <p>
              Майстерня з дванадцяти учнів, які шиють бананки-«дружбанки». 
              Наразі "дружбанки" роблять лише на замовлення. Просувають вироби через соцмережі. 
              Планують зайнятися виробництвом компосту.
              </p>
              <img src= {myFoxImg} alt="Май Fox" />
            </div>
            <div className="example">
              <h3>Проєкт "Шпулька"</h3>
              <p>
              Про що проєкт: Швацько-ткацька шкільна фірма, створена на базі Ворсівського НВК «ДНЗ–ЗНЗ I–II ступенів», що на Житомирщині. Учні виготовляють екоторбинки та продають їх через інтернет.

Результат: Проєкт допомагає учням здобути практичні навички підприємницької діяльності, а також сприяє екологічній свідомості.
              </p>
              <img src= {shpulkaImg} alt="Проєкт Шпулька" />
            </div>
            <div className="example">
              <h3>DOIT - Entrepreneurial skills for young social innovators (Європа)</h3>
              <p>
              Проєкт спрямований на розвиток підприємницьких навичок у молодих соціальних інноваторів через використання методів відкритих інновацій, цифрових інструментів та навичок співпраці.
Проєкт охопив 42 000 дітей та 20 000 фасилітаторів у школах, інноваційних лабораторіях та соціальних підприємствах.
              </p>
              <img src= {doitImg} alt="DOIT - Entrepreneurial skills for young social innovators" />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;